var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calculatedAffordability"},[_c('span',{staticClass:"calculatedAffordabilityHeader",domProps:{"innerHTML":_vm._s(
      _vm.$t('pages.dream_home.calculated_affordability_header', {
        amount: _vm.amount,
      })
    )}}),_c('app-tooltip',{attrs:{"labelKey":"pages.dream_home.calculated_affordability_tooltip"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }